import PropTypes from 'prop-types';
import { Box, Chip } from '@mui/material';
import { Error as ErrorIcon } from '@mui/icons-material';
// Utils and Helpers
import { SOLIDFI_CARD_SHIPPING_STATUS, SOLIDFI_CARD_STATUS } from 'helpers/constants';
import dayjs from 'helpers/dayjs';
// Assets
import './PhysicalCardStatus.css';

const PhysicalCardStatus = ({ card }) => {
    const { solidData: solidfiCardData } = card;

    if (!solidfiCardData) {
        return <Chip label="Requested" className="physical-card-status__chip physical-card-status__chip-pending fw-bold" />;
    }
    if (card.is_system_deactivated || card.isDeactivated) {
        return <Chip label="Frozen" className="physical-card-status__chip physical-card-status__chip-danger fw-bold" />;
    }
    if (card.isCanceled) {
        return <Chip label="Cancelled" className="physical-card-status__chip physical-card-status__chip-secondary fw-bold" />;
    }
    if (solidfiCardData.cardStatus === SOLIDFI_CARD_STATUS.PENDING_ACTIVATION) {
        if (solidfiCardData.shipping.deliveryStatus === SOLIDFI_CARD_SHIPPING_STATUS.PENDING) {
            return (
                <Chip
                    label={
                        <Box display="flex" justifyContent="center" alignItems="center">
                            <Box component="span" marginRight="8px">
                                Ordered
                            </Box>
                            <ErrorIcon sx={{ fontSize: '14px' }} />
                        </Box>
                    }
                    className="physical-card-status__chip physical-card-status__chip-success fw-bold"
                />
            );
        }
        if (solidfiCardData.shipping.deliveryStatus === SOLIDFI_CARD_SHIPPING_STATUS.SHIPPED) {
            return (
                <Chip
                    label={
                        <Box display="flex" justifyContent="center" alignItems="center">
                            <Box component="span" marginRight="8px">
                                Shipped
                            </Box>
                            <ErrorIcon sx={{ fontSize: '14px' }} />
                        </Box>
                    }
                    className="physical-card-status__chip physical-card-status__chip-pending fw-bold"
                />
            );
        }
        if (solidfiCardData.shipping.deliveryStatus === SOLIDFI_CARD_SHIPPING_STATUS.DELIVERED) {
            return (
                <Chip
                    label={
                        <Box display="flex" justifyContent="center" alignItems="center">
                            <Box component="span" marginRight="8px">
                                Delivered
                            </Box>
                            <ErrorIcon sx={{ fontSize: '14px' }} />
                        </Box>
                    }
                    className="physical-card-status__chip physical-card-status__chip-success fw-bold"
                />
            );
        }
        return <Chip label="Pending" className="physical-card-status__chip physical-card-status__chip-pending fw-bold" />;
    }
    return (
        <>
            <Chip label="Active" className="physical-card-status__chip chip-success fw-bold" />
            {card?.autoLock && (
                <Box className="card-table-row__secondary-text-text">Until {dayjs(card?.autoLock).format('MM/DD/YYYY')}</Box>
            )}
        </>
    );
};

PhysicalCardStatus.propTypes = {
    card: PropTypes.object.isRequired
};

export default PhysicalCardStatus;
